import { IV3D } from '@/Interfaces/v3d';

declare let v3d: IV3D;
export const lilacMaterial = new v3d.MeshBasicMaterial({ color: 0xBD9ECD });
export const yellowMaterial=new v3d.MeshBasicMaterial({ color: 0xE8FF50 });
export const lineMeshMaterial=new v3d.MeshBasicMaterial({ color: 0xC91717 });
export const lineMaterial=new v3d.LineBasicMaterial({ color:0x71E885 });
export const dashedLineMaterial=new v3d.LineDashedMaterial ({
    color: 0x0000ff,
    linewidth: 1,
    scale: 1,
    dashSize: 0.5,
    gapSize: 0.3,
});
export const planeMaterial = new v3d.MeshBasicMaterial({ color: 0xC2C9F5, side: v3d.DoubleSide, transparent: true, opacity: 0.7 });

export const defaultTextColor = new v3d.Color(0x080808);
export const textMaterial = new v3d.MeshBasicMaterial(
    { color: 0x080808, depthTest: false },
);
